import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  flex: 1;
  overflow: auto;
`;
export const FilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: flex-end;
`;
export const TaskTablesContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  width: 100%;
  overflow: auto;
  flex: 1;
`;

export const TaskTableContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 400px;
`;

export const TaskTableStyle = {
  border: true,
  rowBorder: true,
  columnPadding: true,
  container: {
    backgroundColor: '#F3F6FA',
    width: '100%',
    flex: 1,
  },
};
